import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';

var _templateObject, _templateObject2;

function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysColorStructureDivider = tokens.sysColorStructureDivider,
      sysSpaceMd = tokens.sysSpaceMd,
      sysBorderThicknessNormal = tokens.sysBorderThicknessNormal,
      sysColorPrimaryContrast = tokens.sysColorPrimaryContrast; // Base class for Divider

  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: divider_base;\n    border: none;\n    border-top: ", " solid ", ";\n    margin: ", " 0;\n  "])), sysBorderThicknessNormal, sysColorStructureDivider, sysSpaceMd); // Inverse State

  var inverse = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: inverse;\n    border-color: ", ";\n  "])), sysColorPrimaryContrast);
  return {
    base: base,
    inverse: inverse
  };
}

var _excluded = ["inverse", "className"];

var Divider = function Divider(_ref) {
  var inverse = _ref.inverse,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var cssVal = [_styles.base, inverse && _styles.inverse];
  return jsx("hr", _extends({
    css: cssVal,
    className: className
  }, rest, {
    "data-ppui-info": "divider_4.1.23"
  }));
};

export { Divider, styles as dividerStyles };